import { Box } from '@razorpay/blade/components';
import api from 'api';
import { routePaths } from 'components/Routes/data';
import { useComponentParams } from 'components/SalaryComponents/hooks';
import {
  WizardError,
  WizardHeader,
  WizardLoader,
  WizardWrapper,
} from 'components/WizardViews/components';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import { useFormWithProvider } from 'forms';
import React from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import GeneralDetailsStep from './GeneralDetailsStep';
import { OvertimeFormData } from './types';
import { convertOTComponentToFormData } from './utils';
import { OT_COMPONENT_LIST_QUERY_KEY } from 'components/SalaryComponents/constants';

const EditOvertimeForm = () => {
  const history = useHistory();
  const { setFormData } = useFormWithProvider<OvertimeFormData>();
  const { componentId } = useComponentParams();
  const isExistingComponent = Boolean(componentId);

  const { isFetching, error, refetch } = useQuery({
    queryKey: [OT_COMPONENT_LIST_QUERY_KEY],
    queryFn: () =>
      api.overtime.queries.listSalaryComponents({
        status: 'OT_STATUS_ACTIVE',
      }),
    enabled: isExistingComponent,
    onSuccess(data) {
      // there will be single overtime component per organization, so we can safely take the first component from the list
      const otComponent = data.overtimeListSalaryComponents.data?.salaryComponents?.[0];
      if (otComponent) {
        setFormData(convertOTComponentToFormData(otComponent));
      }
    },
  });

  const handleCloseClick = () => history.push(routePaths.salaryComponents.root);

  if (isFetching) {
    return <WizardLoader />;
  }

  return (
    <WizardInfoProvider initialStep={0} totalSteps={1}>
      <WizardWrapper>
        <WizardHeader
          heading="Modify"
          subHeading="Overtime Component"
          onCloseClick={handleCloseClick}
        />
        <Box flex={1} overflowY="auto" height="100%">
          <WizardError onRetry={refetch} error={error}>
            <GeneralDetailsStep />
          </WizardError>
        </Box>
      </WizardWrapper>
    </WizardInfoProvider>
  );
};

export default EditOvertimeForm;
